const fr = {
  title: 'Page de paiement',
  subtitle: '',
  status: {
    successTitle: 'Paiement terminé',
    successDescriptionPrefix: '',
    failedTitle: 'Paiement refusé',
    failedDescriptionPrefix: '',
    awaitingTitle: 'Données supplémentaires requises',
    awaitingDescription: 'Le flux nécessite des champs supplémentaires pour continuer.',
    formTitleFallback: 'Renseignez les données demandées',
    redirectTitle: 'Redirection…',
    redirectDescription: 'Si la page ne s\'ouvre pas automatiquement, utilisez le bouton ci-dessous.',
    redirectButton: 'Ouvrir la page',
    infoTitleFallback: 'Informations de paiement',
    infoButton: 'Continuer',
    pendingTitle: 'Traitement en cours',
    pendingDescription: 'En attente de la réponse du prestataire. Vous pouvez actualiser le statut manuellement.',
    refreshButton: 'Actualiser le statut',
    refreshBusy: 'Actualisation…',
    checkAgain: 'Vérifier à nouveau',
    tryAgain: 'Réessayer',
    infoBusy: 'Traitement…',
    redirectLinkAction: 'Retour au site'
  },
  infoDetails: {
    account_name: 'Nom du compte',
    account_number: 'Numéro de compte',
    bank_code: 'Code banque',
    bank_name: 'Nom de la banque',
    expiry_date_in_utc: 'Date d\'expiration (UTC)',
    provider_name: 'Prestataire',
    merchant_name: 'Marchand',
    payment_method: 'Mode de paiement',
    transaction_type: 'Type de transaction'
  },
  order: {
    heading: 'Détails de la commande',
    primaryLabel: 'N° de commande',
    secondaryLabel: 'N° de commande 2',
    providerLabel: 'Prestataire',
    merchantLabel: 'Marchand',
    paymentMethodLabel: 'Mode de paiement',
    transactionTypeLabel: 'Type de transaction',
    transactionLabel: 'ID de transaction',
    transactionRefLabel: 'Référence de transaction',
    amountLabel: 'Montant',
    currencyLabel: 'Devise',
    statusToggleShow: 'Afficher le statut',
    statusToggleHide: 'Masquer le statut',
    transactionTypes: {
      '4': 'Remboursement / Contestation',
      '15': 'Remboursement SBP',
      '16': 'Paiement',
      '17': 'Dépôt'
    },
    paymentMethods: {
      '0': 'T-Money',
      '1': 'M-PESA',
      '2': 'Airtel',
      '3': 'Orange Money',
      '4': 'Afrimoney',
      '5': 'MTN',
      '6': 'Zamtel',
      '7': 'Lumicash',
      '8': 'Virement bancaire',
      '9': 'Carte bancaire',
      '10': 'Simulateur',
      '11': 'Avada Cash',
      '12': 'Tigo',
      '13': 'Vodafone',
      '15': 'Equitel',
      '16': 'Snapscan',
      '17': 'Ozow',
      '18': 'HaloPesa',
      '19': 'Mobile Money Cameroon',
      '20': 'Mobile Money Burkina Faso',
      '21': 'Mobile Money Côte d\'Ivoire',
      '22': 'Mobile Money Zambia',
      '23': 'E-Money',
      '24': 'Free Money',
      '25': 'T-Kash',
      '26': 'Expresso',
      '27': 'Buddy',
      '28': 'Mobile Money Rwanda',
      '29': 'Dalapay Cash',
      '30': 'Wave',
      '31': 'Vodacom',
      '33': 'TOGOCOM',
      '34': 'MOOV Money',
      '35': 'Mobicash',
      '36': 'Pay Attitude',
      '37': 'OPay',
      '38': 'Palmpay',
      '39': 'AzamPesa',
      '40': 'Celtiis',
      '41': 'Agents Network',
      '42': 'Cellulant',
      '43': 'Etisalat',
      '44': 'Instapay',
      '45': 'CIB Smart Wallet',
      '46': 'Bon',
      '47': 'TNM',
      '48': 'EU Mobile',
      '49': 'Youmee',
      '50': 'Yas',
      '51': 'Baridi',
      '52': 'Nagad',
      '53': 'bKash',
      '54': 'EasyPaisa',
      '55': 'JazzCash',
      '56': 'BM Wallet',
      '57': 'Fawry',
      '58': 'Wepay',
      '59': 'EazyPesa',
      '60': 'T-Pesa',
      '61': 'Telcom',
      '62': 'Zeepay',
      '63': 'Biat',
      '64': 'Flouci',
      '65': 'D17',
      '66': 'Tikmoney Cash'
    }
  },
  statusBanner: {
    resultTitle: 'Code résultat',
    providerTitle: 'Réponse prestataire'
  },
  form: {
    submit: 'Continuer',
    selectPlaceholder: 'Choisir…',
    validationFallback: 'Veuillez renseigner ce champ',
    pending: 'Veuillez renseigner ce champ',
    invalidFormat: 'Veuillez saisir une valeur valide',
    processing: 'Traitement…',
    /** Clé = texte legend de l’API, valeur = traduction */
    formLegendTranslations: {
      'Please enter customer full name (will be used for account name and customer details)': 'Veuillez saisir le nom complet du client (sera utilisé pour le nom du compte et les détails client)',
      'Please enter customer email address': 'Veuillez saisir l’adresse e-mail du client',
      'Customer full name': 'Nom complet du client',
      'Customer email address': 'Adresse e-mail du client'
    },
    /** Clé = texte description de l’API, valeur = traduction */
    formDescriptionTranslations: {
      'Customer full name': 'Nom complet du client',
      'Customer email address': 'Adresse e-mail du client'
    }
  },
  error: {
    title: 'Erreur',
    summary: 'La requête n\'a pas pu être traitée.',
    showDetails: 'Afficher les détails techniques',
    hideDetails: 'Masquer les détails techniques',
    retry: 'Réessayer',
    retrying: 'Nouvelle tentative…'
  }
} as const;

export default fr;
